import {
  FormDropdown,
  FormInputDelete,
} from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import Dropzone from 'react-dropzone'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, formValues, reduxForm } from 'redux-form'
import { createMedium, loadMedia } from 'redux/media'
import { Segment } from 'semantic-ui-react'
import ComponentHeader from '../../admin/Helper/ComponentHeader'
import EditModal from './EditModal'
import MediaList from './MediaList'
import Pagination from './Pagination'
import SelectLayout from './SelectLayout'
import UploadButton from './UploadButton'

const mapStateToProps = (state, ownProps) => {
  const { language } = state.navigation
  const { media, uploadingMedia, singleDropzoneUpload } = state.media
  return { language, media, uploadingMedia, singleDropzoneUpload }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      createMedium,
      loadMedia,
      //    registerField
    },
    dispatch
  )
}

class MediaBrowser extends React.Component {
  state = {}

  componentWillMount() {
    const { loadMedia } = this.props
    loadMedia()
  }

  componentWillReceiveProps(newProps) {
    const { filterText: oldFilterText, filterType: oldFilterType } = this.props
    const { filterText: newFilterText, filterType: newFilterType } = newProps
    if (oldFilterText !== newFilterText || oldFilterType !== newFilterType)
      this.setState({ currentPage: 0 })
  }

  render() {
    const dark = config.theme.dark

    const defaultOptions = [
      { text: I18n.t('admin.mediaBrowser.file_type.images'), value: 'image/' },
      {
        text: I18n.t('admin.mediaBrowser.file_type.pdf'),
        value: 'application/pdf',
      },
    ]

    let { currentPage = 0, viewAsList = true } = this.state
    let {
      allowedTypes,
      itemsPerView = 20,
      itemsPerRow = 5,
      customActions,
    } = this.props //ownProps
    let { filterText, filterType } = this.props // formValues
    const {
      media = [],
      uploadingMedia,
      singleDropzoneUpload,
      addMedium,
      createMedium,
    } = this.props // redux

    let filteredMedia = media
    if (allowedTypes)
      filteredMedia = filteredMedia.filter(
        (medium) => allowedTypes.indexOf(medium.content_type) >= 0
      )
    if (filterText)
      filteredMedia = filteredMedia.filter(
        (medium) =>
          (medium.title_de &&
            medium.title_de.toLowerCase().includes(filterText.toLowerCase())) ||
          (medium.title_fr &&
            medium.title_fr.toLowerCase().includes(filterText.toLowerCase())) ||
          (medium.file_name &&
            medium.file_name.toLowerCase().includes(filterText.toLowerCase()))
      )
    if (filterType)
      filteredMedia = filteredMedia.filter((medium) =>
        medium.content_type.startsWith(filterType)
      )

    const totalItems = filteredMedia.length
    const totalPages = Math.ceil(totalItems / itemsPerView)

    const typeOptions = allowedTypes
      ? defaultOptions.filter((option) => allowedTypes.includes(option.value))
      : defaultOptions
    filteredMedia = filteredMedia.slice(
      currentPage * itemsPerView,
      currentPage * itemsPerView + itemsPerView
    )

    const options = [
      { text: I18n.t('admin.mediaBrowser.file_type.all'), value: null },
    ].concat(typeOptions)

    return (
      <div className={classNames(['mediaBrowser', dark && 'inverted'])}>
        <EditModal />
        <ComponentHeader
          inline
          title={I18n.t('admin.mediaBrowser.title')}
          fluid={true}
          customActions={[
            <Field
              className="hide-above-tablet"
              component={FormDropdown}
              options={options}
              placeholder={I18n.t('global.filetype')}
              size="mini"
              name="filterType"
              selection
              fluid
            />,
            <Field
              component={FormInputDelete}
              name="filterText"
              placeholder={I18n.t('global.filter')}
              icon="search"
            />,
            <UploadButton />,
          ]}
        />
        <Segment
          attached
          className={classNames([
            'filterBar',
            'borderless',
            dark && 'inverted',
          ])}>
          <Field
            className="hide-below-tablet"
            component={FormDropdown}
            options={options}
            placeholder={I18n.t('global.filetype')}
            size="mini"
            name="filterType"
            selection
          />
        </Segment>

        <Dropzone
          onDrop={(accepted) => {
            createMedium(accepted)
          }}
          disableClick
          style={{}}
          activeClassName="valid"
          className="dropZone">
          <Segment
            attached
            loading={uploadingMedia && !singleDropzoneUpload}
            className={classNames(['payload', 'small', dark && 'inverted'])}>
            <MediaList
              {...{
                itemsPerView,
                itemsPerRow,
                filteredMedia,
                addMedium,
                viewAsList,
                customActions,
              }}
            />
          </Segment>
        </Dropzone>
        <ComponentHeader
          inline
          footer
          title=""
          fluid={true}
          customActions={[
            <SelectLayout
              {...{
                viewAsList,
                toggleViewStyle: () =>
                  this.setState({ viewAsList: !viewAsList }),
              }}
            />,
            <Pagination
              {...{
                offset: 0,
                currentPage,
                totalPages,
                setPageNumber: (currentPage) => this.setState({ currentPage }),
              }}
            />,
          ]}
        />
      </div>
    )
  }
}

MediaBrowser = connect(mapStateToProps, mapDispatchToProps)(MediaBrowser)
MediaBrowser = formValues('filterText', 'filterType')(MediaBrowser)
MediaBrowser = reduxForm({ form: 'mediaBrowser' })(MediaBrowser)
export default MediaBrowser



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/MediaBrowser.jsx